import ResolutionFilterBar from '../ResolutionFilterBar';
import ResolutionList from '../ResolutionList';

import ResolutionHeader from './ResolutionHeader';
import ResolutionLayout from './ResolutionLayout';
import useResolutionReport from './hooks';

const ResolutionPage = () => {
  const { resolutionReports, isLoading } = useResolutionReport();

  return (
    <ResolutionLayout>
      <div>
        <ResolutionHeader />
        <ResolutionFilterBar />
      </div>
      <ResolutionList resolutionReports={resolutionReports} loading={isLoading} />
    </ResolutionLayout>
  );
};

export default ResolutionPage;
